/* src/app/account/rewardship/rewardship.component.scss */
.flex-center,
.reward-ship .features .feature-wrapper .feature .feature-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.banner {
  display: flex;
  width: 100%;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin: 0 auto 0 auto;
  border-left: 4px solid rgba(0, 71, 145, 0.73);
  background: var(--ups-brand-colors-ups-blue-avatar, #E3EEF9);
  box-shadow: 0px 4px 12px -3px rgba(0, 0, 0, 0.05), 0px 2px 5px 0px rgba(0, 0, 0, 0.14);
}
.banner .text {
  max-width: 100vw;
  flex-shrink: 0;
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
}
.banner .text-link {
  text-decoration-line: underline;
  color: var(--ups-brand-colors-ups-blue, #0662BB);
  cursor: pointer;
}
.banner button,
.banner .mat-mdc-raised-button {
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 32px;
  background: var(--ups-brand-colors-ups-gold, #FFC400) !important;
  color: black;
  border: none;
}
.reward-ship {
  font-size: 1rem;
}
.reward-ship .rewards {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0 23px;
}
@media screen and (min-width: 48rem) {
  .reward-ship .rewards {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.reward-ship .rewards .reward-wrapper {
  width: 100%;
  margin-bottom: 1rem;
}
@media screen and (min-width: 48rem) {
  .reward-ship .rewards .reward-wrapper {
    padding: 0 0.5rem;
  }
}
@media screen and (min-width: 64rem) {
  .reward-ship .rewards .reward-wrapper {
    width: 33.3333333333%;
  }
}
.reward-ship .rewards .reward-wrapper .reward {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2.0625rem;
  background-color: #f4f4f4;
  min-height: 19.875rem;
  width: 100%;
  height: 100%;
  text-align: center;
}
.reward-ship .rewards .reward-wrapper .reward .credit-amount {
  font-size: 3em;
  font-weight: 600;
  margin: 1.25rem 0 1rem;
  line-height: 1;
}
.reward-ship .rewards .reward-wrapper .reward .credit-type {
  font-size: 1.125em;
  font-weight: 600;
  margin-bottom: 0.8125rem;
}
.reward-ship .rewards .reward-wrapper .reward .credit-message {
  font-size: 0.9375em;
  line-height: 1.47;
  color: #817b7b;
}
.reward-ship .rewards .reward-wrapper .reward .credit-action {
  margin-top: auto;
}
.reward-ship .features {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .reward-ship .features {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.reward-ship .features .feature-wrapper {
  width: 100%;
  background-color: #00857d;
}
@media screen and (min-width: 48rem) {
  .reward-ship .features .feature-wrapper {
    padding: 0 0.5rem;
  }
}
@media screen and (min-width: 64rem) {
  .reward-ship .features .feature-wrapper {
    width: 33.3333333333%;
  }
}
.reward-ship .features .feature-wrapper .feature {
  color: rgba(255, 255, 255, 0.87);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.0625rem;
  min-height: 21.875rem;
  width: 100%;
  height: 100%;
  text-align: center;
}
.reward-ship .features .feature-wrapper .feature .feature-icon {
  height: 2.75rem;
  width: 2.375rem;
}
.reward-ship .features .feature-wrapper .feature .feature-icon img {
  height: 100%;
  width: 100%;
}
.reward-ship .features .feature-wrapper .feature .feature-icon ::ng-deep svg {
  height: 100%;
  width: 100%;
}
.reward-ship .features .feature-wrapper .feature .feature-icon ::ng-deep svg g {
  stroke: rgba(255, 255, 255, 0.87);
}
.reward-ship .features .feature-wrapper .feature .feature-title {
  font-size: 1.125em;
  margin: 1.5625rem 0 0.8125rem;
}
.reward-ship .features .feature-wrapper .feature .feature-message {
  font-size: 0.9375em;
  line-height: 1.47;
}
.reward-ship .grid-title {
  color: rgba(36, 36, 36, 0.87);
  font-size: 1.125em;
  font-weight: 600;
  padding-left: 23px;
  margin: 2.375rem 0 1.75rem;
}
@media screen and (min-width: 48rem) {
  .reward-ship .grid-title {
    padding-left: 32px;
  }
}
@media screen and (min-width: 48rem) {
  .reward-ship ::ng-deep .dataTables_wrapper {
    padding: 0 32px;
  }
}
.reward-ship .contact {
  margin-top: 3.75rem;
  padding: 0 23px;
}
@media screen and (min-width: 48rem) {
  .reward-ship .contact {
    padding: 0 32px;
  }
}
.reward-ship .contact .title {
  border-top: solid 2px #d7d7d7;
  color: rgba(36, 36, 36, 0.87);
  font-size: 1.125em;
  font-weight: 600;
  padding: 2.375rem 0 1.75rem;
}
.reward-ship .contact .message {
  font-size: 0.875em;
  line-height: 1.43;
}
.reward-ship .rules {
  font-size: 0.875em;
  padding: 0 23px;
  line-height: 1.57;
  margin: 0.8125rem 0 3.5625rem;
}
@media screen and (min-width: 48rem) {
  .reward-ship .rules {
    padding: 0 32px;
  }
}
.content-disabled {
  filter: brightness(50%);
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=rewardship.component.css.map */
